export class IssueModel {
  id: string;
  name: string;
  lineOfService: string;
  lineOfServiceId: string;
  shortDescription: string;
  lineOfServiceShortDescription: string;
  customerNumbers: Array<string>;
  keywords: Array<string>;
}
